// Janus UK program constants shared by dashboard and enrollment charts.
export const PROGRAM_DAYS = 14;
export const SOWS_MAX_SCORE = 64;
